import { OriginsType } from './config.types';

export const ServiceOrigins: { [key: string]: OriginsType } = {
  LOCAL_SM: {
    TAGGING: 'http://localhost:9090/tagging',
    SM: 'http://localhost:9090/api/v1',
    MW: 'http://localhost:9090/maintenance-window',
    KYC: 'http://localhost:9090/kyc/api',
    BILLING: 'http://localhost:9090/billing',
    TGW: 'http://localhost:9090/cloud-transit-gateway',
    PRIVATE_LINK: 'http://localhost:9090/cloud-resource-link',
    DATABASE: 'http://localhost:9090/cloud-db-service',
    DEDICATED_OFFERING: 'http://localhost:9090/offerings/dedicated',
    BILLING_PRICING: 'http://localhost:9090/cloud-billing-pricing',
    METRICS: 'http://localhost:9090/v1'
  },
  TEST: {
    TAGGING: 'http://localhost',
    SM: 'http://localhost',
    MW: 'http://localhost',
    KYC: 'http://localhost',
    BILLING: 'http://localhost',
    TGW: 'http://localhost',
    PRIVATE_LINK: 'http://localhost',
    DATABASE: 'http://localhost',
    DEDICATED_OFFERING: 'http://localhost',
    BILLING_PRICING: 'http://localhost',
    METRICS: 'http://localhost'
  }
} as const;
